import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCoupons, fetchCouponProducts } from "./coupon.service";
import { CouponsResponse, CouponProductsResponse } from "./coupon.types";
import { handleApiError } from "@/app/utils/handleApiError";
import { FilterRequest } from "../filters/filters.types";

/**
 * Fetch all available coupons
 */
export const getCoupons = createAsyncThunk<
  CouponsResponse,
  void,
  { rejectValue: string }
>("coupon/getCoupons", async (_, { rejectWithValue }) => {
  try {
    const response = await fetchCoupons();
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

/**
 * Fetch products eligible for a specific coupon
 */
export const getCouponProducts = createAsyncThunk<
  CouponProductsResponse & { couponId: number | string },
  { couponId: number | string; page?: number; filters?: Partial<FilterRequest> },
  { rejectValue: string }
>("coupon/getCouponProducts", async ({ couponId, page = 1, filters }, { rejectWithValue }) => {
  try {
    const response = await fetchCouponProducts(couponId, page, filters);
    return { ...response, couponId };
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});